/**
 * Helper functions for authentication-related operations
 */

/**
 * Type guard to check if response indicates a pending user
 */
export const isPendingUserResponse = (response: any): response is { signUpConfirmation: false } => {
  return response && 
         typeof response === 'object' && 
         'signUpConfirmation' in response && 
         response.signUpConfirmation === false;
}; 